export default __webpack_public_path__ + "static/media/vinyl_green.e22a3544.svg";